export default __webpack_public_path__ + "static/media/moon-loader.4703849b.svg";